import { render } from "./CategoryMobile.vue?vue&type=template&id=10972863"
import script from "./CategoryMobile.vue?vue&type=script&lang=js"
export * from "./CategoryMobile.vue?vue&type=script&lang=js"

import "./CategoryMobile.vue?vue&type=style&index=0&id=10972863&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__